"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CuratedCollections() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="228238" id="budućnost-zaštitarskih-usluga" className="bg-background py-20 px-6 md:px-12 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="w-full mb-12 lg:mb-16">
          <h1 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl leading-[1.2] tracking-tighter">
            <span className="text-secondary">Učinkovito</span>&nbsp;<br />
            upravljanje terenskim djelatnicima
          </h1>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          {}
          <div ref={imageRef} className={`w-full lg:w-[60%] relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-full overflow-hidden rounded-lg aspect-[3/4] md:aspect-[4/5] lg:aspect-auto lg:h-[80vh] shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/security_guard_connected_ecosystem.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/security_guard_connected_ecosystem.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/security_guard_connected_ecosystem.png-wvc-sizes" alt="Profesionalni zaštitar s digitalnim sučeljem" className="w-full h-full object-cover transition-transform duration-[20s] ease-linear hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-primary/5 pointer-events-none rounded-lg"></div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`w-full lg:w-[40%] flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="max-w-[540px]">
              <p className="font-default text-lg text-muted-foreground mb-12 leading-relaxed">
                Mobileo je moderan i učinkovit softver za upravljanje radnom snagom koji automatizira radne operacije, povećava produktivnost i omogućuje praćenje svih aktivnosti zaposlenika i mobilnih jedinica u stvarnom vremenu. Namijenjen je tvrtkama iz uslužnog sektora kao zaštita i čišćenja, a koje žele brže, jednostavnije i učinkovitije upravljanje svakodnevnim poslovanjem.
              </p>
              
              <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                <Button asChild variant="default" size="lg" className="rounded-lg px-8 py-4 text-primary-foreground bg-primary hover:bg-primary/90 text-lg font-semibold shadow-3xl">
                  <Link to="#unaprijedite-svoju-tvrtku">
                    Zatražite demo
                  </Link>
                </Button>
                
                <Button asChild variant="outline" size="lg" className="rounded-lg px-8 py-4 border-border text-muted-foreground hover:bg-accent hover:text-accent-foreground text-lg font-semibold bg-transparent">
                  <Link to="/FeaturesPage">
                    Saznajte više
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}